const FIELD = 'input, textarea, select, button';

/** Переводит фокус на поле формы: узел Mantine с `data-path` либо сам элемент ввода, либо обёртка вокруг него. */
export function focusField(node: HTMLElement | null): void {
  const target = node?.matches(FIELD) ? node : node?.querySelector<HTMLElement>(FIELD);
  target?.focus();
  target?.scrollIntoView?.({ block: 'center' });
}

/** Фокус на первое по порядку на экране поле с ошибкой. `errors` — ошибки из `form.onSubmit`. */
export function focusFirstError(root: HTMLElement | null, errors: Record<string, unknown>): void {
  const fields = root?.querySelectorAll<HTMLElement>('[data-path]') ?? [];
  focusField(Array.from(fields).find((node) => errors[node.dataset.path ?? '']) ?? null);
}
